// extracted by mini-css-extract-plugin
export default {"wrapper":"_d767fad2","icon":"_fa22714a","text":"_65f7571c","printHide":"_3160ed0","blurbTitle":"_e79494aa","blurbDetail":"_b6b699fb"};